export default {
  lang: {
    selectAll: 'Valitse kaikki sivut',
    selected: 'Valittu',
    term: 'Artikla',
    deselect: 'Poista valinta',
  },
};
